import { useEffect, useState } from "react";

export const useCountdownTimer = (initialTime = 300) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  // Drive the ticking countdown only after the timer is started
  useEffect(() => {
    if (!hasStarted) {
      return;
    }

    const interval = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          // Stop when we reach 0
          clearInterval(interval);
          // Mark countdown as finished
          setHasStarted(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [hasStarted]);

  // Start (or restart) the timer and apply the 30s disable window
  const resetTimer = () => {
    setRemainingSeconds(initialTime);
    setHasStarted(true);
    setIsDisabled(true);

    const timeout = setTimeout(() => setIsDisabled(false), 30_000);
    return () => clearTimeout(timeout);
  };

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return { minutes, seconds, isDisabled, hasStarted, resetTimer };
};
